import React from 'react';
import { Section } from './content-toggle-reducer';
import AccordionPerson from '../../../shared/accordion-person';
import AccordionDeathData from '../../../shared/accordion-death-data';
import AccordionChangeControlData from '../../../shared/accordion-change-control-data';
import AccordionSubjectList from '../accordion-subject-list';
import AccordionProfession from '../accordion-profession';
import { CodeStepButtonsCancellation } from 'cancellations/constants/code-step-buttons-cancellation';
import JudgmentDataAccordion from 'cancellations/components/shared/accordion-judgment-data';

export type Accordion = {
  key: Section;
  accordion: React.JSXElementConstructor<{
    expanded: boolean;
    toggle: () => void;
    disabled?: boolean;
  }>;
};

export type AccordionToggle = {
  [section in CodeStepButtonsCancellation]?: Accordion[];
};

const commonAccordions: Accordion[] = [
  {
    key: 'person',
    accordion: AccordionPerson,
  },
];

const datiCancellazione: Accordion[] = [
  ...commonAccordions,
  { key: 'controlData', accordion: AccordionChangeControlData },
  { key: 'deathData', accordion: AccordionDeathData },
  { key: 'judgmentData', accordion: JudgmentDataAccordion },
];

const elencoSoggetti: Accordion[] = [
  ...commonAccordions,
  { key: 'controlData', accordion: AccordionChangeControlData },
  { key: 'subjectList', accordion: AccordionSubjectList },
];

const altriDati: Accordion[] = [
  ...commonAccordions,
  { key: 'profession', accordion: AccordionProfession },
];

export const sectionDefinition: AccordionToggle = {
  datiCancellazione,
  elencoSoggetti,
  altriDati,
};
